
define('text!views/pages/itunesTerms.html',[],function () { return '<div class="page page-itunes-terms">\n\n    <div class="pad markdown" data-bind="html: terms"></div>\n\n</div>';});

